import { useMutation } from "react-query";
import http from "infra/http";

function useFinalizarCobranca() {
  return useMutation(
    `v1/cobranca/finalizar`,
    (unidadeId: string) =>
       http.post(`v1/cobranca/${unidadeId}/finalizar`),
  );
}

export default useFinalizarCobranca;
